module.exports = __webpack_public_path__ + "img/HZGB01-03-04.411e672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB01-03-04.png
// module id = m7Si
// module chunks = 0